export default [
  {
    url: '/dashboard',
    name: 'Panel',
    icon: 'HomeIcon',
    i18n: 'Panel',
  },
  {
    header: 'Warehouse',
    icon: 'PackageIcon',
    i18n: 'Warehouse',
    items: [
      {
        url: '/warehouse/brands',
        name: 'Brands',
        slug: 'brands',
        icon: 'TagIcon',
        i18n: 'Brands'
      },
      {
        url: '/warehouse/categories',
        name: 'Categories',
        slug: 'categories',
        icon: 'ShoppingBagIcon',
        i18n: 'Categories'
      },
      {
        url: '/warehouse/products',
        name: 'Products',
        slug: 'products',
        icon: 'StarIcon',
        i18n: 'Products'
      }
    ]
  },
  {
    header: 'Inputs',
    icon: 'ShoppingCartIcon',
    i18n: 'Inputs',
    items: [
      {
        url: '/inputs/providers',
        name: 'Providers',
        slug: 'providers',
        icon: 'MehIcon',
        i18n: 'Providers'
      },
      {
        url: '/inputs/index',
        name: 'Inputs',
        slug: 'inputs',
        icon: 'PlusIcon',
        i18n: 'Inputs'
      }
    ]
  },
  {
    header: 'Outputs',
    icon: 'ShoppingCartIcon',
    i18n: 'Outputs',
    items: [
      {
        url: '/outputs/clients',
        name: 'Outputs',
        slug: 'clients',
        icon: 'HeartIcon',
        i18n: 'Clients'
      },
      {
        url: '/outputs/index',
        name: 'Outputs',
        slug: 'outputs',
        icon: 'MinusIcon',
        i18n: 'Outputs'
      }
    ]
  },
  {
    header: 'Config',
    icon: 'SettingsIcon',
    i18n: 'Config',
    items: [
      {
        url: '/settings/users',
        name: 'Users',
        slug: 'users',
        icon: 'UsersIcon',
        i18n: 'Users'
      }
    ]
  }
]

